/**
 * Email utility functions for formatting sender addresses and email content
 */

/**
 * Format an email sender address with display name
 * @param displayName The display name to show (e.g., "Pack 400 Announcements")
 * @param email The email address (defaults to info@ohc400.org)
 * @returns Formatted sender string in the format "Display Name <email@domain.com>"
 */
export function formatEmailSender(displayName: string, email = "info@ohc400.org"): string {
  return `${displayName} <${email}>`;
}

/**
 * Format group name for email sender display names
 * @param groupName The group name (e.g., "Pack 400", "Troop 400B")
 * @param emailType The type of email being sent
 * @returns Formatted display name for email sender
 */
export function formatGroupEmailSender(groupName: string, emailType: EMAIL_TYPE_DISPLAY_NAMES, email = "info@ohc400.org"): string {
  const displayName = `${groupName} ${emailType}`;
  return formatEmailSender(displayName, email);
}

/**
 * Display names for common email types
 */
export enum EMAIL_TYPE_DISPLAY_NAMES {
  ANNOUNCEMENTS = "Announcements",
  CONFIRMATION = "Email Confirmation", 
  REGISTRATION = "Registration",
  REMINDER = "Reminder",
  CAMPING_REGISTRATION = "Camping Registration",
}